export const showUserlikeChatInit = (isVisible, isAdminView) => {
  let userTab = document.getElementById('userlike-tab')
  let hover = document.getElementById('userlike-hover-text-container')
  if (userTab && hover) {
    if (isAdminView) {
      userTab.style.display = isVisible ? 'inline-block' : 'none'
      userTab.style.bottom = '10px'
      hover.style.bottom = '18px'
    } else {
      userTab.style.display = isVisible ? 'inline-block' : 'none'
      userTab.style.bottom = '73px'
      hover.style.bottom = '73px'
    }
  }
}
function configRollbar(auth) {
  if (!Rollbar) return
  console.log('RollBar ok')
  const data = {
    person: {
      id: auth.uid,
      username: auth.displayName,
      email: auth.email
    },
    custom: {
      uid: auth.uid,
      hiboutikAccount: auth.hiboutikAccount,
      phone:
        auth.boarding && auth.boarding.config
          ? auth.boarding.config.phone
          : null,
      hbUserKey: auth.hbUserKey || null,
      isDemo: auth.isDemo
    }
  }
  Rollbar.configure({ payload: { ...Rollbar.options.payload, data } })
  console.log('RollbarConf : ', Rollbar.options)
}
// function configUserlike(auth) {
//   const data = {
//     user: {
//       name: auth.displayName,
//       email: auth.email
//     },
//     custom: {
//       uid: auth.uid,
//       hiboutikAccount: auth.hiboutikAccount,
//       phone:
//         auth.boarding && auth.boarding.config
//           ? auth.boarding.config.phone
//           : null,
//       hbUserKey: auth.hbUserKey,
//       isDemo: auth.isDemo
//     }
//   }
//   if (userlike && userlike.setData) {
//     userlike.setData(data)
//     userlike.userlikeUpdateAPI()
//   }
// }
export const setUserData = auth => {
  configRollbar(auth)
  // configUserlike(auth)
}



// WEBPACK FOOTER //
// ./src/utils/ReportingUtils.js